import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Inspiration from "@/components/site/Inspiration";
import Lessons from "@/components/site/Lessons";
import Benefits from "@/components/site/Benefits";
import Reminder from "@/components/site/Reminder";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="bg-brand-cream text-brand-charcoal">
      <Navigation />
      <Hero />
      <About />
      <Inspiration />
      <Lessons />
      <Benefits />
      <Reminder />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
